<template>
	<v-alert :value="showAlert" type="info" class="ml-4 mr-4 mb-3 alert">
		Suma kosztów {{ documentNumbers.length > 1 ? 'dokumentów' : 'dokumentu' }} {{documentNumbers.join(", ")}} jest
		większa od {{ documentNumbers.length > 1 ? 'podanych kwot całkowitych' : 'podanej kwoty całkowitej' }}.
	</v-alert>
</template>

<script>
	export default {
		name: "FinalReportInvoicesWarning",

		data () {
			return {
				showAlert: true,
				documentNumbers: []
			};
		},

		watch: {
			invoices: {
				handler (documents) {
					this.showAlert = false;
					this.documentNumbers = [];
					for (let document of documents) {
						let calculated = 0;
						for (let action of document.actions) {
							for (let cost of action.costs) {
								for (let costDivision of cost.costDivisions) {
									if (typeof costDivision.totalPrice !== "number") {
										calculated += Number.parseFloat(costDivision.totalPrice);
									} else {
										calculated += costDivision.totalPrice;
									}
								}
							}
						}
						for (let cost of document.administrative) {
							for (let costDivision of cost.costDivisions) {
								if (typeof costDivision.totalPrice !== "number") {
									calculated += Number.parseFloat(costDivision.totalPrice);
								} else {
									calculated += costDivision.totalPrice;
								}
							}
						}
						if (parseFloat(calculated.toFixed(2)) > parseFloat(document.totalValue.toFixed(2))) {
							this.documentNumbers.push(document.documentNumber);
							this.showAlert = true;
						}
					}
				},
				immediate: true
			}
		},

		props: {
			invoices: {
				type: Array,
				required: true
			}
		}
	};
</script>

<style scoped>
@media print {
	.alert {
		background-color: lightgrey !important;
		color: black;
		border: none;
	}
	.alert >>> .v-icon {
		display: none;
	}
}

</style>
